<div class="data-analytics-wrapper">
    <div class="no-selection" *ngIf="!showDashboard">
        <div class="no-selection-content">
            <p class="message">{{message}}</p>
            <a class="selection" (click)="showFactorySelectionPopup()">Click here to select</a>
        </div>
    </div>

    <div class="data-analytics fw fh" *ngIf="showDashboard">

        <app-da-header (applyFilter)="applyDateFilter($event)" [factoryName]="factorySummary?.factoryName"
            [currrentFilter]="currrentFilter" [currentDate]="currentDate" [filterApplied]="filterApplied"
            [isCurrentURLSaved]="isCurrentURLSaved" [bookmarkList]="bookmarkList"
            (toggleComment)="toggleCommentBox($event)" [factorySummary]="factorySummary"
            [showCommentBox]="isShowCommentBox" [lineName]="lineName" [insightLevel]="level">
        </app-da-header>

        <div class="data-analytics-container" [class.comment]="isShowCommentBox">
            <div (click)="isShowCommentBox=false"  (keydown.enter)="isShowCommentBox = false"
                (keydown.space)="isShowCommentBox = false">
                <app-da-factory-summary [factorySummary]="factorySummary" [zerobasedtarget]="zerobasedtarget">
                </app-da-factory-summary>
            </div>
            <div class="da-center">
                <div class="da-center-top">
                    <div class="loader-div" *ngIf="isLoadingTrend">
                        {{messageTrend}}
                    </div>
                    <div (click)="isShowCommentBox=false" 
                        (keydown.enter)="isShowCommentBox = false" (keydown.space)="isShowCommentBox = false">
                        <app-da-trends [factorySummary]="factorySummary" (applyFilter)="applyDateFilter($event)"
                            [currrentFilter]="currrentFilter" [currentDate]="currentDate" [trendsData]="trendsData"
                            *ngIf="!isLoadingTrend"></app-da-trends>
                    </div>
                </div>
                <div class="da-center-bottom" (click)="isShowCommentBox=false" 
                    (keydown.enter)="isShowCommentBox = false" (keydown.space)="isShowCommentBox = false">
                    <div class="da-rm-pm fh">
                        <app-da-rm-pm [factorySummary]="factorySummary" [levelType]="level" *ngIf="level==='factory'">
                        </app-da-rm-pm>
                        <app-bar-chart *ngIf="level==='line'" [factorySummary]="factorySummary"></app-bar-chart>

                    </div>
                    <div class="da-volume fh">
                        <app-da-volume [factorySummary]="factorySummary" (applyFilter)="applyDateFilter($event)"
                            [currrentFilter]="currrentFilter" [currentDate]="currentDate" *ngIf="level==='factory'">
                        </app-da-volume>
                        <app-bar-line-combo-chart [factorySummary]="factorySummary"
                            (applyFilter)="applyDateFilter($event)" [currrentFilter]="currrentFilter"
                            [currentDate]="currentDate" *ngIf="level==='line'">
                        </app-bar-line-combo-chart>
                    </div>
                </div>
                <div class="da-center-bottomgraph" (click)="isShowCommentBox=false" 
                    (keydown.enter)="isShowCommentBox = false" (keydown.space)="isShowCommentBox = false"
                    *ngIf="level==='line'" [style.display]="level==='line' ? '' : 'none'">
                    <div class="da-rm-pm fh">
                        <app-oee-and-change-over [oeeAndChangeOverData]="oeeAndChangeOverData" [graphType]="'oee'"
                            [factorySummary]="factorySummary" [currrentFilter]="currrentFilter" *ngIf="!isLoading">
                        </app-oee-and-change-over>
                        <h4 *ngIf="isLoading" class="ellipses" title="Cost % vs OEE">Cost % vs OEE</h4>
                        <div class="loader-div" *ngIf="isLoading">
                            {{message}}
                        </div>
                    </div>
                    <div class="da-volume fh">
                        <app-da-rm-pm [factorySummary]="factorySummary" [levelType]="level" *ngIf="level==='line'">
                        </app-da-rm-pm>
                    </div>
                </div>
                <div class="da-center-bottomgraph" (click)="isShowCommentBox=false" 
                    (keydown.enter)="isShowCommentBox = false" (keydown.space)="isShowCommentBox = false"
                    *ngIf="level==='line'" [style.display]="level==='line' ? '' : 'none'">
                    <div class="da-volume-change fh">
                        <app-oee-and-change-over [oeeAndChangeOverData]="oeeAndChangeOverData"
                            [graphType]="'changeOver'" [factorySummary]="factorySummary"
                            [currrentFilter]="currrentFilter" *ngIf="!isLoading">
                        </app-oee-and-change-over>
                        <h4 *ngIf="isLoading" class="ellipses" title="Changeover vs Cost %">Changeover vs Cost %</h4>
                        <div class="loader-div" *ngIf="isLoading">
                            {{message}}
                        </div>
                    </div>
                </div>
            </div>
            <app-da-cost-contributions [factorySummary]="factorySummary"></app-da-cost-contributions>
            <div *ngIf="isShowCommentBox">
                <app-da-comments-shared [factorySummary]="factorySummary" (closeComment)="toggleCommentBox($event)">
                </app-da-comments-shared>
            </div>
        </div>
    </div>
</div>